module.exports = __webpack_public_path__ + "img/background_01.5eaab54f.png";